import React, { useEffect } from 'react';
import { CSSTransition } from 'react-transition-group';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as ModalActions from '../../../../actions/modal';
import SimpleLayer from '../SimpleLayer';
// Auth modals (legacy - pending migration)
import SignupContent from '../../../modals/Signup';
import LoginContent from '../../../modals/Login';
import ForgotPassowrdContent from '../../../modals/ForgotPassword';
// Complex modals (legacy - pending migration)
import CalendarContent from '../../../modals/Calendar';
import AddPaymentMethodContent from '../../../modals/AddPaymentMethod';
import { CheckoutModal as CheckoutContent } from '../../../modals/Checkout';
import PlanTransferContent from '../../../modals/PlanTransfer';
import RenewSubscriptionContent from '../../../modals/RenewSubscription';
import PayInvoiceContent from '../../../modals/PayInvoice';
// Refactored modals (pod-style architecture)
import { ReviewModalContainer } from '../../../modals/review-modal';
import { DeactivateConfirmationModalContainer } from '../../../modals/deactivate-confirmation-modal';
import { ReportIssueModalContainer } from '../../../modals/report-issue-modal';
import { ReportedIssueModalContainer } from '../../../modals/reported-issue-modal';
import { ResolveIssueModalContainer } from '../../../modals/resolve-issue-modal';
import { ResolvedIssueModalContainer } from '../../../modals/resolved-issue-modal';
import { TutorCancelBookingModalContainer } from '../../../modals/tutor-cancel-booking-modal';
import { TutorReportAndResolveIssueModalContainer } from '../../../modals/tutor-report-and-resolve-issue-modal';
import { SetTeamsModalContainer } from '../../../modals/set-teams-modal';
import { LanguageAbilityTableModalContainer } from '../../../modals/language-ability-table-modal';
import { PronunciationModalContainer } from '../../../modals/pronunciation-modal';
import { ShowSummaryModalContainer } from '../../../modals/show-summary-modal';
import { ShowTutorsOnSlotModalContainer } from '../../../modals/show-tutors-on-slot-modal';
import { EditEducationHistoryModalContainer } from '../../../modals/edit-education-history-modal';
import { EditCertificationItemModalContainer } from '../../../modals/edit-certification-item-modal';
import { AddShiftSetModalContainer } from '../../../modals/add-shift-set-modal';
import { EditShiftSetModalContainer } from '../../../modals/edit-shift-set-modal';

function mapStateToProps(state) {
  const { modal } = state;
  const { isOpen, content, modalProps, message, messageType } = modal;
  return {
    isOpen,
    content,
    modalProps,
    message,
    messageType,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    modalActions: bindActionCreators<any, any>(ModalActions, dispatch),
  };
}

const ModalContainer = (props) => {
  let modalContent;
  const { isOpen, modalActions, modalProps, content, message, messageType } =
    props;
  useEffect(() => {
    if (isOpen) {
      // Safari, EdgeではbodyのStyleを直接変更することが出来ない。classやlangはOK
      try {
        document.body.className += 'modal-open';
      } catch (err) {
        console.log('Attempted to assign to readonly property.');
      }
    } else {
      try {
        document.body.className = '';
      } catch (err) {
        console.log('Attempted to assign to readonly property.');
      }
    }
  }, [isOpen]);

  const showModal = (contentName, passedProps = {}) => {
    modalActions.show(contentName, passedProps);
  };

  const hideModal = (e = null) => {
    if (e) e.preventDefault();
    modalActions.hide();
  };

  const addModalMessage = (passedMessage, opts = {}) => {
    modalActions.addMessage(passedMessage, opts);
  };

  const clearModalMessage = () => {
    modalActions.clearMessage();
  };

  const hideModalPromise = () => {
    return new Promise<void>((resolve) => {
      hideModal();
      window.setTimeout(() => {
        resolve();
      }, 300);
    });
  };

  const transitModal = async (nextContent, passedProps = {}) => {
    await hideModalPromise();
    showModal(nextContent, passedProps);
  };

  const baseModalProps = {
    addModalMessage,
    clearModalMessage,
    hideModal,
    transitModal,
    message,
    messageType,
  };
  const combinedModalProps = Object.assign(baseModalProps, { ...modalProps });

  switch (content) {
    case 'signup':
      modalContent = <SignupContent {...combinedModalProps} />;
      break;
    case 'login':
      modalContent = <LoginContent {...combinedModalProps} />;
      break;
    case 'forgotPassword':
      modalContent = <ForgotPassowrdContent {...combinedModalProps} />;
      break;
    case 'bookingCalendar':
      modalContent = <CalendarContent {...combinedModalProps} />;
      break;
    case 'setTeams':
      modalContent = <SetTeamsModalContainer {...combinedModalProps} />;
      break;
    case 'review':
      modalContent = <ReviewModalContainer {...combinedModalProps} />;
      break;
    case 'pronunciation':
      modalContent = <PronunciationModalContainer {...combinedModalProps} />;
      break;
    case 'deactivateConfirmation':
      modalContent = (
        <DeactivateConfirmationModalContainer {...combinedModalProps} />
      );
      break;
    case 'editEducationHistory':
      modalContent = (
        <EditEducationHistoryModalContainer {...combinedModalProps} />
      );
      break;
    case 'editCertificationItem':
      modalContent = (
        <EditCertificationItemModalContainer {...combinedModalProps} />
      );
      break;
    case 'languageAbilityTable':
      modalContent = (
        <LanguageAbilityTableModalContainer {...combinedModalProps} />
      );
      break;
    case 'showSummary':
      modalContent = <ShowSummaryModalContainer {...combinedModalProps} />;
      break;
    case 'reportIssue':
      modalContent = <ReportIssueModalContainer {...combinedModalProps} />;
      break;
    case 'reportedIssue':
      modalContent = <ReportedIssueModalContainer {...combinedModalProps} />;
      break;
    case 'tutorCancelBooking':
      modalContent = (
        <TutorCancelBookingModalContainer {...combinedModalProps} />
      );
      break;
    case 'resolveIssue':
      modalContent = <ResolveIssueModalContainer {...combinedModalProps} />;
      break;
    case 'resolvedIssue':
      modalContent = <ResolvedIssueModalContainer {...combinedModalProps} />;
      break;
    case 'reportAndResolveIssue':
      modalContent = (
        <TutorReportAndResolveIssueModalContainer {...combinedModalProps} />
      );
      break;
    case 'addPaymentMethod':
      modalContent = <AddPaymentMethodContent {...combinedModalProps} />;
      break;
    case 'checkout':
      modalContent = <CheckoutContent {...combinedModalProps} />;
      break;
    case 'planTransfer':
      modalContent = <PlanTransferContent {...combinedModalProps} />;
      break;
    case 'renewSubscription':
      modalContent = <RenewSubscriptionContent {...combinedModalProps} />;
      break;
    case 'payInvoice':
      modalContent = <PayInvoiceContent {...combinedModalProps} />;
      break;
    case 'showAvailableTutorsOnSlot':
      modalContent = (
        <ShowTutorsOnSlotModalContainer {...combinedModalProps} />
      );
      break;
    case 'addShiftSet':
      modalContent = <AddShiftSetModalContainer {...combinedModalProps} />;
      break;
    case 'editShiftSet':
      modalContent = <EditShiftSetModalContainer {...combinedModalProps} />;
      break;
    default:
      modalContent = <div />;
      break;
  }
  const simpleLayer = !modalProps.outerClickDisabled ? (
    <SimpleLayer onClick={hideModal} />
  ) : null;
  if (isOpen) {
    return (
      <CSSTransition appear={true} timeout={500}>
        <div className="fixed inset-0 z-40 overflow-y-auto bg-black/75">
          <div className="table h-full w-full table-fixed">
            <div className="table-cell h-full w-full align-middle p-0 sm:p-[50px]">
              {simpleLayer}
              <div
                className={`relative z-40 ${!modalProps.outerClickDisabled ? 'pointer-events-none [&>*]:pointer-events-auto' : ''}`}
              >
                {modalContent}
              </div>
            </div>
          </div>
        </div>
      </CSSTransition>
    );
  } else {
    return (
      <CSSTransition appear={true} timeout={500}>
        <div />
      </CSSTransition>
    );
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalContainer);
